<template>
  <div class="chat-panel">
    <div class="chat-header">
      <div class="user-bar">
        <div class="messaging-profile-picture" @click="$root.$emit('getProfile', getChatUser.userID)" :style="'background-image: url(' + $imageus + (getChatUser.user.image != null ? getChatUser.user.image : 'https://holacon.s3.eu-central-1.amazonaws.com/public/default-user.png') + '?width=100&height=100&mode=cover);'"></div>
        <span @click="$root.$emit('getProfile', getChatUser.userID)">
          {{ chat.title }}
          <div v-if="chat.unread > 0" class="unread-count">{{ chat.unread }}</div>
        </span>
      </div>

      <el-dropdown>
        <span class="el-dropdown-link">
          <i class="fas fa-ellipsis-v" style="color: #aeb5c3; cursor:pointer;"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="$root.$emit('getProfile', getChatUser.userID)">{{ $t("view_profile") }}</el-dropdown-item>
          <el-dropdown-item @click.native="clearChat(chat)">{{ $t("clear_messages") }}</el-dropdown-item>
          <el-dropdown-item @click.native="deleteChat(chat)">{{ $t("delete_chat") }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-tooltip class="item" effect="dark" :content="$t('close')" placement="top-start">
        <i class="fas fa-times" style="color: #aeb5c3; margin-left: 20px; cursor:pointer;" @click="$emit('close', chat.id)"></i>
      </el-tooltip>
    </div>

    <div class="messages" :id="chat.id">
      <infinite-loading direction="top" @infinite="getData">
        <div class="nomorepost" slot="no-more">
          <span>{{ $t("no_more_message") }}</span>
        </div>
        <div class="nomorepost" slot="no-results">
          <span>{{ $t("no_message") }}</span>
        </div>
      </infinite-loading>

      <div v-for="(message, index) in chat.messages" :key="message.id" class="message-wrapper">
        <img v-if="message.image != null" :src="message.image" alt="" class="message-img" :class="message.user.id == $store.state.user.id ? 'me' : ''" />
        <div class="message" v-if="message.messageText != null && message.messageText != ''" :class="message.user.id == $store.state.user.id ? 'me' : ''">
          <div v-html="parseUrl(message.messageText, message.id)"></div>
        </div>
        <span class="message-time" v-if="(chat.messages[index + 1] != null && chat.messages[index + 1].user.id != message.user.id) || chat.messages.length == index + 1 || (timeDiff(message.createDate) >= 5 && chat.messages[index + 1] != null && timeDiff(message.createDate) != timeDiff(chat.messages[index + 1].createDate))" :class="message.user.id == $store.state.user.id ? 'me' : ''">
          <i class="fas fa-clock"></i>
          <span>{{ calculateDate(message.createDate).fromNow() }}</span>
        </span>
      </div>
    </div>

    <div class="send" @keydown.enter.exact.prevent @keyup.enter.exact="send">
      <el-input class="message-input" v-model="message" :placeholder="$t('write_message')" :disabled="sending">
        <template slot="prepend">
          <div class="message-input-icon">
            <i :class="sending ? 'fa fa-spinner fa-spin' : 'camera-icon'" v-if="imageURL == null" @click="select"></i>
            <img :src="imageURL" alt="Selected Image" v-else />
            <template v-if="imageURL">
              <i class="fa fa-spinner fa-spin" v-if="imageURL && loading == 'uploadToServer'"></i>
              <i class="fa fa-times" v-else @click="clearImage"></i>
            </template>
          </div>
        </template>
        <template slot="append">
          <div class="message-input-icon">
            <i :class="sending ? 'fa fa-spinner fa-spin' : 'send-icon'" @click="send"></i>
          </div>
        </template>
      </el-input>
      <input type="file" @change="uploadFile" style="display: none" ref="file" />
      <!-- <textarea @keydown.enter.exact.prevent @keyup.enter.exact="send" name id v-model="message" cols="30" rows="10" :disabled="sending" :placeholder="$t('write_message')" />
      <div class="send-now" @click="!sending ? send : {}">
        <i :class="sending ? 'fa fa-spinner fa-spin' : 'fa fa-paper-plane'"></i>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment/min/moment-with-locales";

import InfiniteLoading from "vue-infinite-loading";
import $ from "jquery";

export default {
  name: "ChatPanel",
  components: { InfiniteLoading },
  props: ["id"],
  data() {
    return {
      message: null,
      messageSub: null,
      loading: false,
      scrollcalctimeout: null,
      moment,
      chatIndex: null,
      sending: false,
      locked: false,
      image: null,
      imageURL: null,
      timeout:null,
    };
  },
  created() {
    var chatIndex = this.$store.state.chats.findIndex(k => k.id == this.id);

    this.$store.state.unreadMessages = 0;
    this.$store.state.activeChatPanelId = this.id;

    this.chatIndex = chatIndex;

    this.$socket.emit("subscribe", {
      channel: "message-" + this.id,
      token: ""
    });

    this.$socket.on("message-" + this.id + "-newMessage", data => {
      data = data.data;
      var chatIndex = this.$store.state.chats.findIndex(k => k.id == this.id);

      this.$store.state.chats[chatIndex].unread = 0;

      this.$store.state.chats[chatIndex].messages.push({
        messageText: data.MessageText,
        createDate: data.CreateDate,
        id: data.Id,
        image: data.Image,
        messageGroupID: data.MessageGroupID,
        userID: data.UserID,
        user: {
          id: data.User.Id,
          image: data.User.Image,
          title: data.User.Title
        }
      });

      setTimeout(() => {
        var elem = document.getElementById(this.id);
        if (elem.scrollTop + 100 >= elem.scrollHeight - elem.offsetHeight) {
          elem.scrollTop = elem.scrollHeight;
        }
      }, 0);
    });
  },
  computed: {
    chat() {
      return this.$store.state.chats.find(k => k.id == this.id);
    },

    getChatUser() {
      return this.chat.recipients.find(k => k.userID != this.$store.state.user.id);
    }
  },

  methods: {
    clearImage() {
      this.image = null;
      this.imageURL = null;
      this.$refs.file.value = null;
    },
    select() {
      this.$refs.file.click();
    },
    async uploadFile() {
      let file = this.$refs.file.files[0];
      this.image = file;
      this.imageURL = URL.createObjectURL(file);
      this.$refs.file.value = null;
    },
    calculateDate(date) {
      return moment(date).add(-5, "seconds");
    },
    timeDiff(starTime) {
      var now = moment(new Date());
      var start = moment(starTime).add(-10, "seconds");
      var duration = moment.duration(now.diff(start));
      var minutes = Math.floor(duration.asMinutes());
      return minutes;
    },
    parseUrl(text, message) {
      if (text == null) return;
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      var imageRegex = /(https?:\/\/.*\.(?:png|jpg|gif|webp))/i;
      var img = null;

      var modifiedText = text.replace(imageRegex, function(match) {
        return '<img style="border-radius: 8px; display: block; max-width: 220px;" src="' + match + '"/>';
      });

      var finalText = modifiedText.replace(urlRegex, function(match) {
        return '<a href="' + match + '" target="_blank">' + match + "</a>";
      });

      return finalText;
    },

    async clearChat(chat) {
      var res = await axios.post("chat/deleteallmessages", { id: chat.id });
      if (!res.data.hasError) {
        var index = this.$store.state.chats.findIndex(k => k.id == chat.id);
        this.$store.state.chats[index].messages = [];
        this.$store.state.chats[index].lastMessage = null;
        this.$emit("close", this.chat.id);
      }
    },

    deleteChat(chat) {
      axios.post("chat/deletemessagegroup", { id: chat.id }).then(res => {
        var index = this.$store.state.chats.findIndex(k => k.id == chat.id);
        this.$store.state.chats.splice(index, 1);
      });
      this.$emit("close", this.chat.id);
    },

    async getData($state) {
      var chatIndex = this.$store.state.chats.findIndex(k => k.id == this.chat.id);

      var response = await axios.post("Chat/listMessages", {
        skip: this.$store.state.chats[chatIndex].messages.length,
        take: 10,
        messageGroupID: this.chat.id
      });

      this.$store.state.chats[chatIndex].messages.unshift(...response.data.data.items.reverse());

      if (response.data.data.items.length == 0) $state.complete();
      else $state.loaded();
    },

    async send() {
      if (this.image == null) {
        if (this.message == null && this.message == "") {
          return;
        }
      }
      var sendingImage = null;
      if(this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.image != null) {
          this.loading = "uploadToServer";
          var fd = new FormData();
          fd.append("file", this.image);
          var res = await axios.post(`account/uploadfile?uploadType=message`, fd, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });
          if (res.data.hasError) {
            this.$message.error(res.data.message);
            this.loading = false;
            return;
          } else {
            sendingImage = res.data.data.item.url;
          }
          this.loading = false;
        }
        this.locked = true;
        this.sending = true;
        var response = await axios.post("chat/sendmessage", {
          messageText: this.message,
          messageGroupID: this.id,
          image: sendingImage
        });
        if (response.data.hasError) {
          this.$message.error(response.data.message);
        }
        this.message = null;
        this.image = null;
        this.imageURL = null;
        this.$refs.file.value = null;
        this.locked = false;
        this.sending = false;
      }, 250);
    },

    scrollCalc() {
      this.scrollcalctimeout = setTimeout(() => {
        axios.post("chat/readall", { id: this.id });

        var chatIndex = this.$store.state.chats.findIndex(x => x.id == this.id);
        if (chatIndex != -1) {
          this.$store.state.chats[chatIndex].unread = 0;
          var elem = document.getElementById(this.id);
          elem.scrollTop = elem.scrollHeight;
        }
      }, 250);
    }
  },

  mounted() {
    this.scrollCalc();
  },

  beforeDestroy() {
    this.$store.state.activeChatPanelId = null;

    this.$socket.off("message-" + this.id + "-newMessage");
    this.$socket.emit("unsubscribe", "message-" + this.id);
    clearTimeout(this.scrollcalctimeout);
  }
};
</script>

<style lang="less">
.chat-panel {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  border-radius: 16px;
  padding-left: 10px;

  .unread-count {
    background-color: #50bfbf;
    padding: 3px 6px;
    border-radius: 4px;
    color: white;
    text-align: center;
    margin-left: 6px;
    font-size: 12px;
    display: inline;
  }

  .messages {
    transition: 0.3s;
    overflow: auto;
    height: 305px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .message-wrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 4px;
      justify-content: center;
    }
    .message-time {
      display: flex;
      align-items: center;
      gap: 4px;
      font-weight: 500;
      font-size: 11px;
      color: #8c929c;
      margin-left: 10px;
      i {
        font-size: 14px;
      }

      &.me {
        align-self: flex-end;
        margin-right: 10px;
      }
    }
    .message-img {
      width: 70%;
      border-radius: 8px;
      object-fit: cover;
      align-self: flex-start;
      &.me {
        align-self: flex-end;
      }
    }
    .message {
      display: inline-block;
      background-color: #e8ebef;
      border-radius: 8px;
      word-break: break-word;
      max-width: 400px;
      padding: 10px;
      align-self: flex-start;
      color: #505763;
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      // span {
      //   font-size: 10px;
      //   margin-left: 10px;
      //   color: #8c929c;
      // }

      &.me {
        align-self: flex-end;
        margin-right: 10px;
        background-color: rgba(123, 211, 212, 0.17);
        span {
          font-size: 10px;
          margin-left: 10px;
          color: #8c929c;
        }
      }
    }
  }

  .chat-header {
    color: #292f3b;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 2;
    border-bottom: 1px solid #c8cdd3;
    margin-bottom: 8px;
    padding-bottom: 8px;
    .md-button {
      min-width: 36px;
      height: 36px;
    }

    .user-bar {
      display: flex;
      flex: 1;
      align-items: center;
      gap: 8px;
      .messaging-profile-picture {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
        border: 3px solid #f1f1f1;
        width: 32px;
        height: 32px;
        display: inline-block;
        cursor: pointer;
      }

      span {
        cursor: pointer;
        color: #505763;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
      }
    }
    i.fa-times,
    i.fa-ellipsis-v {
      font-size: 14px;
      color: #505763 !important;
    }
  }
}

.send {
  width: 100%;
  height: 60px;
  position: relative;
  display: flex;
  flex-direction: row;
  padding-top: 12px;
  justify-content: flex-end;
  .send-now {
    position: absolute;
    right: 16px;
    top: 22px;
    cursor: pointer;
  }

  textarea {
    outline: none;
    width: 100%;
    margin-top: 10px;
    height: 50px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px 15px;
    font-size: 13px;
    padding-right: 30px;
    border: 0.5px solid #d6d9d9;
    background: #fff;
    border-radius: 8px;
    font-family: "Roboto";
    resize: none;
  }
}

.nomorepost {
  padding: 15px 20px;

  span {
    padding: 8px 20px;
    border-radius: 16px;
    font-weight: 500;
    color: #292f3b;
  }
}

@media (max-width: 768px) {
  .chat-panel-container {
    width: 100%;
    height: calc(~"100vh - 160px") !important;

    .chat-panel {
      width: 100%;
      height: 100%;
      min-width: unset;
      padding-left: 0px;

      .messages {
        overflow-y: scroll;
        height: calc(~"100% - 225px") !important;
      }

      .send {
        width: 100%;
        height: 60px;
        position: relative;

        textarea {
          width: calc(100% - 0px);

          margin: 0px;
        }

        .send-now {
          right: 16px;
          top: 16px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/ChatPanel.vue